import { render, staticRenderFns } from "./UnitCardExclusions.vue?vue&type=template&id=c33134dc&"
import script from "./UnitCardExclusions.vue?vue&type=script&lang=js&"
export * from "./UnitCardExclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports